import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "react-toastify";
import { truncateAddress } from "../../../../lib/format";

// Truncated hash + copy-full-value button. Pass href to make the text a link.
export function CopyHash({ value, head = 8, tail = 6, href }) {
  const [copied, setCopied] = useState(false);
  if (!value) return <span className="text-muted-foreground">—</span>;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      toast.error("Couldn't copy to clipboard");
    }
  };

  return (
    <span className="inline-flex items-center gap-1.5 font-mono">
      {href ? (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          title={value}
          className="text-ginox-green hover:underline"
        >
          {truncateAddress(value, head, tail)}
        </a>
      ) : (
        <span title={value}>{truncateAddress(value, head, tail)}</span>
      )}
      <button
        type="button"
        onClick={copy}
        aria-label="Copy full hash"
        className="text-muted-foreground/60 transition-colors hover:text-foreground"
      >
        {copied ? <Check className="h-3.5 w-3.5 text-emerald-400" /> : <Copy className="h-3.5 w-3.5" />}
      </button>
    </span>
  );
}
